module.exports = __webpack_public_path__ + "img/3.efae14ef.png";